var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-container',{staticClass:"browser-window",attrs:{"fluid":"","fill-height":""}})
}
var staticRenderFns = []

export { render, staticRenderFns }